import { DirtLevelEnum } from 'api';
import { SelectField, SelectFieldProps, SelectOption } from 'form';

type MaterialDirtLevelProps = Omit<SelectFieldProps, 'options'>;

const MaterialDirtLevelDisplayedOptions: SelectOption[] = [
  {
    label: 'Very Clean',
    value: DirtLevelEnum.VC,
  },
  {
    label: 'Clean',
    value: DirtLevelEnum.CL,
  },
  {
    label: 'Dirty',
    value: DirtLevelEnum.DI,
  },
  {
    label: 'N/A',
    value: 'n/a',
  },
];

export const MaterialDirtLevel = ({ label, name, ...rest }: MaterialDirtLevelProps) => {
  return (
    <SelectField
      label={label}
      name={name}
      type="text"
      options={MaterialDirtLevelDisplayedOptions}
      required={false}
      {...rest}
    />
  );
};
